var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GetAppLinks',{attrs:{"title":_vm.$t('layout.getApp.footerTitle'),"get-via-text":_vm.$t('layout.getApp.getVia')}})}
var staticRenderFns = []

export { render, staticRenderFns }